exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container[data-v-536c815e] {\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0.25rem;\n}\n.image-container img[data-v-536c815e] {\n  margin: 0;\n}\n.resize-icon[data-v-536c815e] {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n}\n[data-v-536c815e].resize-icon {\n  cursor: se-resize !important;\n}", ""]);

// exports
